export default {
  'offer-status': "Estado de la oferta",
  'offer-no': "Número de oferta",
  'payment-terms': "Términos de pago",
  'validity-days': "Período de validez de la oferta"
}
